import { useEffect } from 'react';
import { Container, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrorMsg, fetchPaises } from '../../appStore/commonSlice';
import { createNewCv, cvSelector, fetchExtraData, fetchInitialData } from './cvSlice';
import {
  ItemsAcademicos,
  ItemsCapacitaciones,
  ItemsIdiomas,
  ItemsInformaticos,
  ItemsInstitucionales,
  ItemsLaborales,
  ItemsPublicaciones,
} from './itemTypes';
import Seccion from './Seccion';

export const CvUsuarioCongelado = ({
  id = null,
  idPuesto = null,
  acciones = true,
  encabezado = true,
  validarItems = true,
  requisitos = true,
  botonMas,
}) => {
  const state = useSelector(cvSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPaises()); //para los items de cv que ya están mostrando paises
    dispatch(fetchExtraData({ msg: 'Preparando...' })).then(() => {
      dispatch(fetchInitialData({ id, msg: 'Cargando datos de CV...' })).then((action) => {
        if (action.payload?.code === 'noCV') {
          dispatch(createNewCv({ msg: 'Generando nuevo CV...' })).then((action) => {
            if (!action.error) {
              dispatch(clearErrorMsg());
            }
          });
        }
      });
    });
  }, [dispatch, id]);

  return (
    <>
      {encabezado && (
        <Container>
          <Row>
            <Form.Text muted style={{ fontSize: 14, marginTop: 15 }}>
              Recuerde que deberá adjuntar la documentación que respalde los antecedentes
              declarados, la que se encontrará sujeta validación. La omisión de la misma implicará
              que el antecedente ingresado en el portal web, no será considerado a los efectos de
              las distintas etapas del proceso de selección, considerándose sólo la documentación
              validada.
            </Form.Text>
          </Row>
        </Container>
      )}

      {Object.keys(state).length > 0 && (
        <>
          <Seccion
            active
            title="Antecedentes Académicos"
            itemsComponent={
              <ItemsAcademicos
                items={state.antecedentesAcademicos}
                acciones={acciones}
                validarItems={validarItems}
                idItems="items_academicos"
                botonMas={botonMas}
              />
            }
          />
          <Seccion
            title="Actividades de capacitación"
            itemsComponent={
              <ItemsCapacitaciones
                items={state.capacitacion}
                acciones={acciones}
                validarItems={validarItems}
                idItems="items_capacitacion"
                botonMas={botonMas}
              />
            }
          />
          <Seccion
            title="Publicaciones o trabajos"
            itemsComponent={
              <ItemsPublicaciones
                items={state.publicaciones}
                acciones={acciones}
                validarItems={validarItems}
                idItems="items_publicaciones"
                botonMas={botonMas}
              />
            }
          />
          <Seccion
            title="Antecedentes Laborales"
            itemsComponent={
              <ItemsLaborales
                items={state.antecedentesLaborales}
                acciones={acciones}
                validarItems={validarItems}
                idItems="items_laborales"
                botonMas={botonMas}
              />
            }
          />
          <Seccion
            title="Actividades docentes"
            itemsComponent={
              <ItemsInstitucionales
                items={state.institucionales}
                acciones={acciones}
                validarItems={validarItems}
                idItems="items_docentes"
                botonMas={botonMas}
              />
            }
          />
          <Seccion
            title="Idiomas Extranjeros"
            itemsComponent={
              <ItemsIdiomas
                items={state.idiomas}
                acciones={acciones}
                validarItems={validarItems}
                idItems="items_idiomas"
                botonMas={botonMas}
              />
            }
          />
          <Seccion
            title="Conocimientos Informáticos"
            itemsComponent={
              <ItemsInformaticos
                items={state.informaticos}
                acciones={acciones}
                validarItems={validarItems}
                idItems="items_informaticos"
                botonMas={botonMas}
              />
            }
          />
          {/* {requisitos && (
            <Seccion
              title="Validación de Requisitos Excluyentes"
              itemsComponent={<TablaValidacionRequisitos requisitos={requisitosCargados} />}
            />
          )} */}
        </>
      )}
    </>
  );
};
